export const unitPilotMode = {
  AUTO: "AUTO",
  MANUAL: "MANUAL",
  SYSTEM_DEFAULT: "SYSTEM_DEFAULT"
};
